










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Language } from '@/types/Language';
import { TextLocalization } from '@/interfaces/TextLocalization';
import UITexts from '@/data/UITexts';

@Component({})
export default class GoToDesktopComponent extends Vue {
  @Prop()
  userEmail!: string;

  @Prop()
  language: Language | undefined;

  textLocalizations: TextLocalization[] = UITexts;

  get textProvider() {
    const language = this.language === undefined ? 0 : this.language;
    return this.textLocalizations[language];
  }

  get paragraphWithUsersEmail() {
    return this.textProvider.gotoDesktopScreen!.paragraph4!.replace('{userEmail}', this.userEmail);
  }
}
